// src/views/auth/slice/selectors.ts
import { Selector } from 'react-redux';
import { RootState } from '../../../redux/store';
import authSlice from './slice';
import { Nullable } from '../../../types';
import { ActivateError, ApiError } from '../../../services/ApiService.types';
import { polishServerText } from '../../../utils/apiErrors';

const getIsSignUp = (state: RootState) => state[authSlice.name].isSignUpAccount;
const getSignUpError = (state: RootState) => state[authSlice.name].signUpError;

const getIsAuthenticating = (state: RootState) => state[authSlice.name].isLoggingIn;
const getIsActivatingAccount = (state: RootState) => state[authSlice.name].isActivatingAccount;
const getAuthError = (state: RootState) => state[authSlice.name].authError;
const getActivationError = (state: RootState) => state[authSlice.name].activationError;
// Tekst backendu tylko wtedy, gdy to jego własny komunikat: string przy błędzie 4xx. Tablica to
// angielskie błędy walidacji, 5xx i brak odpowiedzi to awaria — wtedy `null` i widok daje tekst ogólny.
// Serwer pisze po polsku, więc przy innym języku interfejsu też `null`
const getActivationErrorText = (state: RootState): Nullable<string> => {
  const activationError: Nullable<ActivateError> = getActivationError(state);

  return typeof activationError?.message === 'string' && activationError.statusCode < 500
    ? polishServerText(activationError.message)
    : null;
};
// Własny komunikat backendu przy 400 to zawsze nieważny link — gdy jego tekstu nie pokazujemy (inny język),
// widok daje swój tekst o nieważnym linku zamiast ogólnego
const getIsActivationLinkRejected = (state: RootState): boolean => {
  const activationError: Nullable<ActivateError> = getActivationError(state);

  return typeof activationError?.message === 'string' && activationError.statusCode === 400;
};
const getUserData = (state: RootState) => state[authSlice.name].userData;
const getActiveList = (state: RootState) => state[authSlice.name].activeList;
// Tylko jawne `true` z `@me`. Profil zapisany przed katalogiem nie ma tego pola — to zwykłe konto.
const getCanCurate = (state: RootState): boolean => state[authSlice.name].userData?.canCurate === true;

export const getIsResettingPassword = (state: RootState) => (
  state[authSlice.name].isResettingPassword
);
export const getResetPasswordError: Selector<RootState, Nullable<ApiError>> = (state) => (
  state[authSlice.name].resetPasswordError
);

export {
  getIsAuthenticating,
  getAuthError,
  getActivationError,
  getActivationErrorText,
  getIsActivationLinkRejected,
  getIsActivatingAccount,
  getUserData,
  getIsSignUp,
  getSignUpError,
  getActiveList,
  getCanCurate,
};
